import { Children, useState, useEffect, type ReactNode } from 'react';

export interface KVGridProps {
  children: ReactNode;
  /** Override manual. Sin él, la decisión es del componente: más de
   * cuatro filas → dos columnas; cuatro o menos → una. */
  columns?: 1 | 2;
}

export function KVGrid({ children, columns }: KVGridProps) {
  const count = Children.count(children);
  const cols = columns ?? (count > 4 ? 2 : 1);
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 959px)').matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 959px)');
    const handler = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (cols === 1 || narrow) {
    return <div>{children}</div>;
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: 'var(--evo-space-4)',
      alignItems: 'stretch',
    }}>
      {children}
    </div>
  );
}
